import cube from './cube';

export default cube;